var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-image',{staticClass:"pictures",attrs:{"src":_vm.text,"preview-src-list":_vm.srcList}})}
var staticRenderFns = []

export { render, staticRenderFns }